interface GameStatisticItemProps {
  title: string;
  home: number;
  guest: number;
  customClass?: string;
}

function GameStatisticItem({ title, home, guest, customClass = '' }: GameStatisticItemProps) {
  return (
    <div className="static-item-container">
      <div className="statistic-item team-home">
        {home}
      </div>

      <div className="statistic-title">
        { title }
      </div>

      <div className="statistic-item team-guest">
        {guest}
      </div>
    </div>
  );
}

export default GameStatisticItem;